import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
      maxHeight: "100vh",
    },
    dialogRoot: {
      maxHeight: "100vh",
    },
    contentContainer: {
      flex: 1,
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
      overflow: "auto",
    },
    inputContainer: {
      flex: 1,
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    cardHeading: {
      paddingLeft: theme.spacing(1),
      color: theme.palette.grey["600"],
    },
    inputContainerSx: {
      width: "100%",
      padding: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  })
);
